import { render, staticRenderFns } from "./stockTransactionDataTable.vue?vue&type=template&id=8f9db950&"
import script from "./stockTransactionDataTable.vue?vue&type=script&lang=js&"
export * from "./stockTransactionDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports